export default {
  INTERACT_W_CONTRACT_WRITE: 'InteractWithContractWriteButtonClicked',
  INTERACT_W_CONTRACT_WRITE_SUCCESS: 'InteractWithContractWriteSuccess',
  INTERACT_W_CONTRACT_WRITE_FAIL: 'InteractWithContractWriteFail',
  INTERACT_W_CONTRACT_READ: 'InteractWithContractReadButtonClicked',
  INTERACT_W_CONTRACT_READ_SUCCESS: 'InteractWithContractReadSuccess',
  INTERACT_W_CONTRACT_READ_FAIL: 'InteractWithContractReadFail',
  DEPLOY_CONTRACT: 'DeployContractButtonClicked',
  DEPLOY_CONTRACT_SUCCESS: 'DeployContractSuccess',
  DEPLOY_CONTRACT_FAIL: 'DeployContractFail',
  NAVIGATE_TO_INTERACT: 'NavigateToInteract',
  NAVIGATE_TO_DEPLOY: 'NavigateToDeploy'
};
